/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NtsAppRootModule, NtsBootService, StdModule } from '@nts/std';
import { EnvironmentConfiguration, UNPROXIED_ENVIRONMENT, unproxiedEnvironmentFactory } from '@nts/std/environments';
import { environment } from 'src/environments/environment';
import { environment as devEnvironment } from 'src/environments/environment.dev';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { NAVIGATION_STRATEGY } from './shared/navigation/services/navigation-strategy.factory';
import { ConfigurationLoader } from '@nts/std/utility';
import { firstValueFrom } from 'rxjs';
import { config } from 'devextreme/common';
import { provideSvgIcons } from '@ngneat/svg-icon';
import { coreIcons } from './svg/core';
import { LeftRightToolbarUpDownFieldsNavigationStrategy } from './shared/navigation/services/left-right-toolbar-up-down-fields-navigation-strategy.service';
import { InstallPromptComponent } from './shared/pwa/install-prompt.component';

export function initializerDevExtremeLicenseFactoryFunction(
    configurationLoader: ConfigurationLoader,
) {
    return async () => {
        // Carica la licenza di DevExtreme se presente nella configurazione
        const configuration: any = await firstValueFrom(configurationLoader.getConfiguration());

        if (configuration?.devExtreme?.licenseKey?.length > 0) {
            config({ licenseKey: configuration.devExtreme.licenseKey });
        }
    };
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        StdModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),
        InstallPromptComponent
    ],
    providers: [
        {
            provide: EnvironmentConfiguration,
            useValue: { ...environment }
        },
        {
            provide: UNPROXIED_ENVIRONMENT,
            useFactory: unproxiedEnvironmentFactory(devEnvironment),
            deps: [EnvironmentConfiguration]
        },
        ...StdModule.getRootProviders(),
        // Carica la licenza di DevExtreme
        {
            provide: APP_INITIALIZER,
            useFactory: initializerDevExtremeLicenseFactoryFunction,
            deps: [
                ConfigurationLoader,
            ],
            multi: true
        },
        ...SharedModule.getRootProviders(),
        {
            provide: NAVIGATION_STRATEGY,
            useExisting: LeftRightToolbarUpDownFieldsNavigationStrategy,
        },
        provideSvgIcons(coreIcons),
    ],
    bootstrap: [AppComponent]
})

export class AppModule extends NtsAppRootModule {

    constructor(
        bootService: NtsBootService,
    ) {
        super(
            bootService
        );
    }
}
